import { Controller } from "@hotwired/stimulus"

// Champ à étiquettes libres, pour les questions dont la réponse ne tient pas
// dans une liste écrite d'avance — les outils non validés par l'entreprise, par
// exemple, qu'on note au fil de la conversation.
//
// Les étiquettes sont construites ici et non en ERB : le balisage d'une
// étiquette n'existe alors qu'à un seul endroit, et un champ qui s'alimente à
// la touche Entrée n'aurait de toute façon aucun sens sans JavaScript.
//
// La borne `max` n'est pas une contrainte de saisie mais un garde-fou sur la
// taille du JSONB : elle est placée si haut qu'aucune conversation réelle ne
// l'atteint, et son dépassement est donc volontairement silencieux.
export default class extends Controller {
  static targets = ["list", "input", "suggestion"]
  static values = { name: String, tags: Array, max: Number, length: Number }

  keydown(event) {
    if (event.key === "Enter" || event.key === ",") {
      // Sans ce preventDefault, Entrée soumettrait l'étape entière et ferait
      // quitter la question au lieu d'ajouter l'étiquette.
      event.preventDefault()
      this.commit()
    } else if (event.key === "Backspace" && this.inputTarget.value === "") {
      this.tagsValue = this.tagsValue.slice(0, -1)
    }
  }

  // Également appelé au blur : quitter le champ avec un nom en cours de frappe
  // ne doit pas le perdre.
  commit() {
    this.add(this.inputTarget.value)
    this.inputTarget.value = ""
  }

  addSuggestion(event) {
    this.add(event.currentTarget.dataset.tag)
    this.inputTarget.focus()
  }

  remove(event) {
    const index = Number(event.currentTarget.dataset.index)

    this.tagsValue = this.tagsValue.filter((_tag, position) => position !== index)
    this.inputTarget.focus()
  }

  // Le dédoublonnage ignore la casse, comme côté Ruby : « ChatGPT » et
  // « chatgpt » sont le même outil, et la première graphie saisie l'emporte.
  add(value) {
    const tag = value.trim().slice(0, this.lengthValue)

    if (tag === "") return
    if (this.tagsValue.length >= this.maxValue) return
    if (this.tagsValue.some((existing) => existing.toLowerCase() === tag.toLowerCase())) return

    this.tagsValue = [...this.tagsValue, tag]
  }

  tagsValueChanged() {
    this.render()
    // Le formulaire réévalue l'affichage conditionnel et la désactivation des
    // champs masqués : les champs cachés qui portent les étiquettes viennent
    // d'être recréés.
    this.dispatch("changed")
  }

  render() {
    if (!this.hasListTarget) return

    this.listTarget.replaceChildren(...this.tagsValue.map((tag, index) => this.pill(tag, index)))
    this.suggestionTargets.forEach((button) => {
      button.hidden = this.chosen(button.dataset.tag)
    })
  }

  chosen(tag) {
    return this.tagsValue.some((existing) => existing.toLowerCase() === tag.toLowerCase())
  }

  // Construit l'étiquette en DOM plutôt qu'en innerHTML : le texte vient du
  // clavier du consultant, il ne doit jamais être interprété comme du balisage.
  pill(tag, index) {
    const pill = document.createElement("span")
    pill.className = "capture-tag"

    const label = document.createElement("span")
    label.textContent = tag
    pill.appendChild(label)

    const remove = document.createElement("button")
    remove.type = "button"
    remove.className = "capture-tag-remove"
    remove.textContent = "×"
    remove.dataset.index = index
    remove.dataset.action = "capture-tags#remove"
    remove.setAttribute("aria-label", `Retirer ${tag}`)
    pill.appendChild(remove)

    const field = document.createElement("input")
    field.type = "hidden"
    field.name = this.nameValue
    field.value = tag
    field.dataset.tagValue = ""
    pill.appendChild(field)

    return pill
  }
}
